import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PermissionState {
  modulePermissions: object;
  detailedPermissions: object;
  sidebarCollapsed: boolean;
}

const initialState: PermissionState = {
  modulePermissions: {},
  detailedPermissions: {},
  sidebarCollapsed: false,
};

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setUserPermission: (state, action: PayloadAction<{ modulePermissions: {}, detailedPermissions: {} }>) => {
      state.modulePermissions = action.payload.modulePermissions;
      state.detailedPermissions = action.payload.detailedPermissions;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    }
  },
});

export const { setUserPermission, setSidebarCollapsed } = permissionSlice.actions;
export default permissionSlice.reducer;
